Array.from(document.querySelectorAll('.js-styler-buy-link')).forEach((el) => {
    el.addEventListener('click', () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'lg-styler',
                eventCategory: 'wtb-styler',
                eventAction: `{{${el.dataset.name}}}`,
                eventLabel: '{{click lick}}',
            });
        }
    });
});
